<div class="container-fluid" *ngIf="id > 0">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumb-title border-0 mb-3">
        <div
          class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
        >
          <i class="bi bi-grid"></i>
          <p class="mb-0">Application Menu</p>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card">
        <div class="card-header p-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-2"
          >
            <h6 class="mb-0">{{ form.data.name }} Application Menus Items</h6>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <button
                mat-stroked-button
                color="primary"
                class="ms-2"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
              >
                Preview
              </button>

              <button
                mat-stroked-button
                color="primary"
                class="ms-2"
                [routerLink]="['/menuslist', id]"
              >
                <mat-icon style="margin-right: 5px">add</mat-icon>
                Add New Menu
              </button>
            </div>
          </div>
        </div>

        <div class="card-body">
          <!--Message-->
          <div class="col-12">
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert [message]="form['message']" type="success" />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert [message]="form['message']" type="danger" />
            </p>
          </div>

          <div class="row g-3">
            <!--Form Contain-->
            <div class="col-lg-12">
              <div class="card h-100">
                <div class="card-header border-bottom-0">
                  <div class="me-2">
                    <div class="row border-bottom g-4 mb-3">
                      <div class="col-12">
                        <h6 class="mb-3">Form Menu</h6>
                      </div>
                    </div>

                    <div
                      class="d-flex justify-content-start align-items-center mb-3 flex-wrap"
                      style="gap: 8px"
                    >
                      <label class="m-0">Role:</label>
                      <mat-form-field
                        appearance="outline"
                        class="role-select-field"
                      >
                        <mat-select
                          [(ngModel)]="curRoleId"
                          name="roleId"
                          (selectionChange)="onRoleChange()"
                        >
                          <mat-option [value]="0"
                            >-- Default Role --</mat-option
                          >
                          <mat-option *ngFor="let e of roles" [value]="e['id']">
                            {{ e["name"] }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div
                      class="row g-2 align-items-center"
                      *ngIf="curRoleId == 0"
                    >
                      <!-- Usecase Select -->
                      <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>Select Usecase</mat-label>
                          <mat-select
                            [(ngModel)]="menuform.data['userstoryId']"
                            name="usecaseId"
                            (selectionChange)="getFormList()"
                          >
                            <mat-option disabled [value]="undefined">
                              --Select Usecase--
                            </mat-option>
                            <mat-option
                              *ngFor="let e of usecases"
                              [value]="e['id']"
                            >
                              {{ e["name"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- Form Select -->
                      <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>Select Form</mat-label>
                          <mat-select
                            [(ngModel)]="menuform.data['formId']"
                            name="formId"
                            (selectionChange)="onFormChange()"
                          >
                            <mat-option disabled [value]="undefined">
                              --Select Form--
                            </mat-option>
                            <mat-option
                              *ngFor="let e of forms"
                              [value]="e['id']"
                            >
                              {{ e["title"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- Title Input -->
                      <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>Title</mat-label>
                          <input
                            matInput
                            [(ngModel)]="menuform.data['title']"
                            name="title"
                          />
                        </mat-form-field>
                      </div>

                      <!-- URL Input -->
                      <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>URL</mat-label>
                          <input
                            matInput
                            [(ngModel)]="menuform.data['url']"
                            name="url"
                          />
                        </mat-form-field>
                      </div>

                      <!-- New Tab Checkbox (hidden) -->
                      <div class="col-md-2 col-6">
                        <mat-checkbox
                          [(ngModel)]="menuform.data['new_tab']"
                          color="primary"
                          name="new_tab"
                          matTooltip="checked - menu open in new windows"
                        >
                          New tab
                        </mat-checkbox>
                      </div>

                      <!-- Add Button -->
                      <div class="col-6 col-md-2">
                        <button
                          mat-stroked-button
                          color="primary"
                          type="button"
                          (click)="addMenu()"
                        >
                          <mat-icon>add</mat-icon>
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body card-body-list p-0">
                  <app-recursive-menu
                    [menus]="getNestedMenus()"
                    [menusArray]="curMenus"
                    [editor]="this"
                    [level]="1"
                    [edit]="curRoleId == 0"
                  />
                </div>
              </div>
            </div>

            <!--Report Contain-->
            <div class="col-lg-12">
              <div class="card h-100">
                <div class="card-header border-bottom-0">
                  <div class="me-2">
                    <div class="border-bottom mb-3">
                      <div class="mb-3">
                        <h6 class="mb-0">Report Assign</h6>
                      </div>
                    </div>

                    <!-- Role Select -->
                    <div
                      class="d-flex justify-content-start align-items-center mb-3 flex-wrap"
                      style="gap: 8px"
                    >
                      <label class="m-0">Role:</label>
                      <mat-form-field
                        appearance="outline"
                        class="compact-form-field"
                      >
                        <mat-select
                          [(ngModel)]="reportRoleId"
                          name="roleId"
                          (selectionChange)="onRoleChange()"
                        >
                          <mat-option [value]="0"
                            >-- Default Role --</mat-option
                          >
                          <mat-option *ngFor="let e of roles" [value]="e['id']">
                            {{ e["name"] }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Report Selection Section -->
                    <div
                      class="row g-2 align-items-end"
                      *ngIf="reportRoleId == 0"
                    >
                      <!-- Report Select -->
                      <div class="col-12 col-sm-6 col-md-4">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>Select Report</mat-label>
                          <mat-select
                            [(ngModel)]="menuform.data['reportId']"
                            name="reportId"
                            (selectionChange)="
                              getReport(menuform.data['reportId'])
                            "
                          >
                            <mat-option disabled [value]="undefined">
                              --Select Report--
                            </mat-option>
                            <mat-option
                              *ngFor="let e of reportlist"
                              [value]="e['id']"
                            >
                              {{ e["title"] }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- Report Title Input -->
                      <div class="col-12 col-sm-6 col-md-4">
                        <mat-form-field
                          appearance="outline"
                          class="compact-form-field w-100"
                        >
                          <mat-label>Report Title</mat-label>
                          <input
                            matInput
                            [(ngModel)]="menuform.data['reporttitle']"
                            name="reporttitle"
                          />
                        </mat-form-field>
                      </div>

                      <!-- Add Button -->
                      <div class="col">
                        <button
                          mat-stroked-button
                          color="primary"
                          type="button"
                          (click)="addReport()"
                        >
                          <mat-icon>add</mat-icon>
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body card-body-list p-0">
                  <app-recursive-report
                    [menus]="getNestedReports()"
                    [menusArray]="reportMenus"
                    [editor]="this"
                    [level]="1"
                    [edit]="reportRoleId == 0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteModal"
  tabindex="-1"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirm Deletion</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">Are you sure you want to delete this item?</div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDelete()"
          data-bs-dismiss="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRight"
  aria-labelledby="offcanvasRightLabel"
>
  <div class="offcanvas-header d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <h6 id="offcanvasRightLabel" class="mb-0">Menus Preview</h6>
      <button
        mat-stroked-button
        color="primary"
        class="mb-1"
        (click)="expandAll()"
      >
        Expand All
      </button>
    </div>

    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <app-menu [menus]="getNestedMenus()" [menusArray]="curMenus"></app-menu>
    </div>
  </div>
</div>